import React from "react";
import ReactDOM from "react-dom/client";
// ─── Self-hosted variable fonts (Facelift Fase 0) ──────────────────────
// Variable axes replace Google-CDN Fraunces. Loaded before index.css so
// @fontsource CSS is available when Tailwind classes resolve.
import "@fontsource-variable/fraunces";       // wght 100-900, opsz 9-144
import "@fontsource-variable/inter";          // wght 100-900
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
